export const sumByProperty = propertyName => results => results.reduce((total, result) => {
  if (result && result.data && result.data.properties && result.data.properties[propertyName] && result.data.properties[propertyName].value !== undefined) {
    return total + Number(result.data.properties[propertyName].value);
  }
  return total;
}, 0);